import { useState, useCallback } from "react";

export function useLoading() {
  const [isLoading, setIsLoading] = useState(false);

  const whenLoading = useCallback(async (callback: () => Promise<unknown>) => {
    setIsLoading(true);
    try {
      return await callback();
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, whenLoading };
}
